<template>
  <div>
    <p class="content">
      服务器种子： <span>{{ seed }}</span> （刷新查看最新种子）
    </p>
    <el-button type="primary" @click="setrefreshSeeds">刷新</el-button>
  </div>
</template>
<script>
import { getApiData, patchApiData, getData, postData, patchData } from '../../http'
export default {
  data() {
    return {
      seed: ''
    }
  },
  created() {
    this.getRefreshSeeds()
  },
  methods: {
    getRefreshSeeds() {
      getApiData('battle_serve_code').then((res) => {
        this.seed = res
      })
    },
    setrefreshSeeds() {
      patchApiData('battle_serve_code').then((res) => {
        this.getRefreshSeeds()
        this.$message.success("刷新成功！")
      })
    }
  }
}
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  line-height: 100px;
  span {
    font-weight: 600;
    color: rgb(5, 209, 114);
  }
}
</style>